import './index.scss';

import { Component, ComponentClass, ComponentType, Fragment, FunctionComponent, ReactElement, ReactNode } from 'react';

import { BraxAvatar } from '../BraxAvatar';
import { BraxIcon } from '../BraxIcon';
import { BraxLogo, BraxLogoProps } from '../BraxLogo';
import { BraxTooltip } from '../BraxTooltip';

type BraxAppBarItemWrapper = FunctionComponent<{ children: ReactElement }> | ComponentClass<{ children: ReactElement }>;

export type BraxAppBarMenuItems = {
    type: 'logo',
    key: string,
    variant: BraxLogoProps['variant'],
    tooltip?: ReactNode,
    wrapper?: BraxAppBarItemWrapper,
    onClick?: () => void
} | {
    type: 'icon',
    key: string,
    icon: string | ReactNode,
    label: string,
    tooltip?: ReactNode,
    wrapper?: BraxAppBarItemWrapper,
    onClick?: () => void
} | {
    type: 'avatar',
    key: string,
    src: string,
    alt: string,
    tooltip?: ReactNode,
    wrapper?: BraxAppBarItemWrapper,
    onClick?: () => void
} | {
    type: 'avatar',
    key: string,
    firstName: string,
    lastName: string,
    tooltip?: ReactNode,
    wrapper?: BraxAppBarItemWrapper,
    onClick?: () => void
};

export type BraxAppBarLinkComponent = ComponentType<{ className: string, children: ReactNode } & ({ to: string } | { onClick: () => void })>;

export type BraxAppBarProps = {
    open: boolean,
    active: string,
    menuItems: BraxAppBarMenuItems[][],
    children: ReactNode,
    linkComponent: BraxAppBarLinkComponent
}

export class BraxAppBar extends Component<BraxAppBarProps> {

    static defaultProps = {
        open: false
    };

    render() {
        const Link = this.props.linkComponent;

        return (
            <div className={`brax-app-bar ${this.props.open ? 'open' : ''}`}>
                <nav>
                    { this.props.menuItems.map((menuItems, i) => (
                        <div key={i}>
                            { menuItems.map(({ key, ...menuItem }) => {
                                let node = (<Link
                                    className={menuItem.type !== 'logo' && key === this.props.active ? 'active' : ''}
                                    {...(!menuItem.onClick ? {
                                        to: `/${key}`
                                    } : {
                                        onClick: menuItem.onClick
                                    })}
                                >
                                    { menuItem.type === 'logo'
                                        ? <BraxLogo type="icon" variant={menuItem.variant} />
                                    : menuItem.type === 'avatar'
                                        ? <BraxAvatar {...menuItem} />
                                        : (<>
                                            { typeof menuItem.icon === 'string' ? (
                                                <BraxIcon icon={menuItem.icon} />
                                            ) : menuItem.icon }

                                            <span>{ menuItem.label }</span>
                                        </>)
                                    }
                                </Link>);

                                if (menuItem.tooltip)
                                    node = (<BraxTooltip placement="right" tooltip={menuItem.tooltip}>{ node }</BraxTooltip>);

                                if (menuItem.wrapper)
                                    node = (<menuItem.wrapper>{ node }</menuItem.wrapper>);

                                return (<Fragment key={key}>{ node }</Fragment>);
                            }) }
                        </div>
                    )) }
                </nav>

                <div>
                    { this.props.children }
                </div>
            </div>
        );
    }

}
